import type { TourTranslation } from "./index";

export const german = {
  ap_label: "Ausnahmebehandlung in der Kreditorenbuchhaltung",
  ap_intro_title: "Rechnungsverarbeitung in Buchhaltungsteams",
  ap_intro_lead: "Dies ist eine Demo zur Rechnungsverarbeitung in Buchhaltungsteams.",
  ap_intro_body:
    "Die Rechnungsverarbeitung ist zunehmend automatisiert, Ausnahmen erfordern aber weiterhin manuelle Arbeit. Die Kernmetrik sind manuelle Eingriffe pro Rechnung. Aber wie findet man die vorgelagerten Fehler, die sie verursachen?",
  ap_failures_body:
    "Platonic kartiert Ihre Arbeitsabläufe und zeigt drei Fehlermuster: PO-Preisabweichungen, Mengenabweichungen und fehlende Wareneingänge.",
  ap_filter_body:
    "Preisabweichungen können auf vorgelagerte Prozessfehler hinweisen. Mit Platonic zoomen Sie hinein, indem Sie sie in Alltagssprache beschreiben.",
  ap_filter_prompt: "PO Invoice price mismatch",
  ap_ask_body:
    "Manuelle Untersuchung kostet Zeit. Fragen wir den Prozess direkt. Zum Beispiel: \u201eWhy is there a price mismatch between POs and invoices?\u201c",
  ap_prompt: "Why is there a price mismatch between POs and invoices?",
  ap_answer_body:
    "Der Chat zeigte, dass wenige Artikel die meisten Ausnahmen verursachen: veraltete Verträge im PO-System führen zu wiederkehrenden Rechnungsabweichungen.",
  ap_monitor_body:
    "Die betroffenen POs zu aktualisieren behebt das Problem, es kann aber bei anderen Verträgen erneut auftreten. Wie erkennt man es früh?",
  ap_watch_prompt: "Find a list of items that lead to recurring invoice PO price mismatch.",
  ap_watch_title: "Nicht aktualisierte POs",
  ap_kpi_body:
    "Platonic verfolgt nicht aktualisierte POs als KPI, mit einem regelmäßigen Bericht direkt ins Postfach, z. B. \u201eFind a list of items that lead to recurring invoice PO price mismatch\u201c.",
  hr_label: "Schlüsselpersonen-Risiko in HR-Teams",
  hr_intro_title: "Schlüsselpersonen-Risiko in HR-Teams",
  hr_intro_body:
    "Ein Private-Equity-Fonds hat ein Unternehmen übernommen. Bevor HR zentralisiert, ausgelagert oder umgebaut wird, muss klar sein, wo kritisches Wissen sitzt und welche Prozesse von einzelnen Personen abhängen.",
  hr_map_body: "Nehmen wir das Kandidaten-Screening als Beispiel…",
  hr_inspect_body:
    "…ein kurzer Blick zeigt, dass sich die Mitarbeitenden bei komplexeren F\u00e4llen oft aufeinander verlassen.",
  hr_ask_body:
    "Mit Platonic k\u00f6nnen Sie den Prozess direkt befragen und den Kontext dahinter verstehen.",
  hr_prompt: "Provide context on why a colleague was consulted in this task",
  hr_answer_body:
    "Der Chat zeigte, dass eine Person die meisten dieser Fälle bearbeitet und das kritische Wissen für die Randfälle besitzt.",
  hr_monitor_body: "Aber wie erkennt man dasselbe Muster über alle Prozesse der Funktion hinweg?",
  hr_wask_body:
    "Fragen Sie Platonic direkt, wie die Arbeit im HR-Team verteilt ist und wo Schlüsselpersonen-Risiken und operative Abhängigkeiten liegen.",
  hr_watch_prompt:
    "Analyze how work is distributed across the HR team and identify any key-person risks or operational dependencies. Who holds unique process knowledge, who is most frequently relied on by colleagues, which activities depend disproportionately on specific individuals, and what risks would arise if one person were unavailable?",
  hr_wanswer_body:
    "Die Analyse bestätigte, dass eine Person der operative Knotenpunkt des HR-Teams ist und einen Großteil des Wissens für dessen Prozesse hält.",
  cs_label: "Wissensl\u00fccken im Customer Service",
  cs_intro_title: "Wissenslücken im Customer Service",
  cs_intro_body:
    "Customer-Service-Teams stützen sich auf Wissensdatenbanken und Playbooks. Sind diese unvollständig oder veraltet, dauern Fälle länger und erfordern mehr Suchen, Interaktionen und Eskalationen. Wie findet man die Lücken?",
  cs_filter_body:
    "Platonic lässt Sie auf bestimmte Fälle zoomen, indem Sie sie in Alltagssprache beschreiben.",
  cs_filter_prompt: "top 10 longest time",
  cs_node_body:
    "Die längsten Fälle verbringen überproportional viel Zeit mit der Suche in der Wissensdatenbank. Sehen wir uns diesen Schritt an.",
  cs_insight_body:
    "Diese Suchen sind langsam und führen oft zu Eskalation statt Lösung — ein Hinweis auf Lücken in der Wissensdatenbank. Aber welche Lücken treiben das Problem?",
  cs_ask_body: "Platonic l\u00e4sst Sie den Prozess direkt befragen.",
  cs_prompt: "Which gaps/ambiguity in the policies emerge from these processes?",
  cs_answer_body:
    "Die Analyse zeigt wiederkehrende L\u00fccken rund um EU-Widerrufsrechte, automatische Verl\u00e4ngerungen, Reseller-Erstattungen und Alt-Tarife.",
  cs_monitor_body:
    "Sobald die Lücken geschlossen sind: Woher wissen Sie, dass die neue Anleitung tatsächlich wirkt?",
  cs_watch_prompt:
    "Find unresolved knowledge-base searches and the escalation rate that follows them. Highlight recurring topics where agents fail to find relevant guidance, and show whether these gaps improve over time.",
  cs_watch_title: "KB-Lücken",
  cs_kpi_body:
    "Platonic l\u00e4sst Sie Wissensdatenbank-L\u00fccken als KPI verfolgen, mit einem periodischen Report direkt in Ihr Postfach, z. B. \u201eFind unresolved knowledge-base searches and the escalation rate that follows them, highlight recurring topics where agents fail to find relevant guidance, and show whether these gaps improve over time\u201c.",
  demo_label: "Kostenmanagement im Einkauf",
  demo_intro_lead: "Dies ist eine Demo zum Kostenmanagement in Einkaufsteams.",
  demo_intro_body:
    "Einkaufskosten hängen von verhandelten Verträgen ab. Schwache Konditionen nachzuverhandeln oder Lieferanten zu wechseln kann Kosten erheblich senken. Aber wie findet man diese Chancen?",
  start: "Starten",
  demo_blueprint_body:
    "Platonic zeichnet Bildschirmaktivität, Klicks und App-Nutzung in Ihrem Team auf und macht daraus einen Bauplan davon, wie die Arbeit tatsächlich erledigt wird.",
  demo_graph_body: "Echte Prozesse sind schwer zu lesen…",
  demo_map_body: "Platonic bildet die Arbeitsabläufe Ihres Unternehmens ab.",
  demo_deviations_body:
    "Eine häufige Abweichung vom Standardprozess ist die externe Lieferantensuche, die die Kosten erhöhen kann. Prüfen wir, ob das der Fall ist.",
  demo_ask_body:
    "Platonic lässt Sie den Prozess direkt befragen, zum Beispiel: „Zeige eine Tabelle einzigartiger Artikel mit Durchschnittskosten für Lieferanten mit und ohne Vertrag“.",
  demo_prompt:
    "Zeige eine Tabelle einzigartiger Artikel mit Durchschnittskosten für Lieferanten mit und ohne Vertrag",
  demo_watch_prompt:
    "Finde alle Käufe über externe Anbieter, obwohl ein Vertragspartner verfügbar war",
  demo_watch_title: "Nutzung nicht vertraglich gebundener Anbieter",
  demo_answer_body:
    "Die Daten bestätigen: Lieferanten ohne Vertrag kosten deutlich mehr als vertraglich gebundene.",
  demo_monitor_body: "Die Lösung ist, Vertragsnutzung durchzusetzen, aber wie überwacht man das?",
  demo_kpi_body:
    "Platonic verfolgt Off-Contract-Käufe als KPI, mit einem regelmäßigen Bericht direkt ins Postfach, z. B. „Finde alle Käufe über externe Anbieter, obwohl ein Vertragspartner verfügbar war“.",
  demo_cta_title: "Bereit loszulegen?",
  demo_cta_body: "Sehen Sie, was Platonic in der Arbeit Ihres Teams findet.",
  demo_cta_hint: "Sie können jederzeit über die Schaltfläche unten rechts eine Live-Demo buchen.",
  demo_book_demo: "Demo buchen",
  demo_request_access: "Zugang anfragen",
  demo_waitlist_name_placeholder: "Vollständiger Name",
  demo_waitlist_email_placeholder: "Geschäftliche E-Mail",
  demo_waitlist_area_label: "Welchen Bereich möchten Sie mit Platonic verbessern?",
  demo_waitlist_area_placeholder: "Bereich auswählen",
  demo_waitlist_area_other_placeholder: "Welchen?",
  demo_waitlist_area_procurement: "Einkauf",
  demo_waitlist_area_finance: "Finanzen",
  demo_waitlist_area_customer_service: "Kundenservice",
  demo_waitlist_area_supply_chain: "Lieferkette",
  demo_waitlist_area_operations: "Betrieb",
  demo_waitlist_area_sales: "Vertrieb",
  demo_waitlist_area_human_resources: "Personalwesen",
  demo_waitlist_area_it: "IT",
  demo_waitlist_area_other: "Sonstiges",
  demo_waitlist_done_title: "Sie stehen auf der Warteliste.",
  demo_waitlist_done_body:
    "Wir prüfen Ihre Anfrage und senden Ihnen die Einrichtungsanleitung, sobald der Zugang bereit ist.",
  demo_waitlist_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  welcome_body: "Willkommen! Diese Demo bietet eingeschränkten Funktionsumfang.",
  welcome_cta_prefix: "Für Zugang zu allen Produktfunktionen: ",
  welcome_cta_link: "buchen Sie eine Demo",
  welcome_gallery:
    "Entdecken Sie unsere Bibliothek von Anwendungsfällen, um Platonic in Aktion zu sehen.",
  target_missing_toast_title: "Tour beendet",
  target_missing_toast_message:
    "Dieser Teil der App ist gerade nicht verfügbar. Versuchen Sie es erneut, sobald Daten vorhanden sind.",
  back: "Zurück",
  next: "Weiter",
  done: "Fertig",
  settings_title: "Erste-Schritte-Guide",
  settings_help: "Die geführte Produktdemo.",
  demo_user_import: "Demo-Benutzer",
  demo_user_import_card_description:
    "Die Personen einer Demo aus einer Datei anlegen und die ganze Demo wieder entfernen.",
  demo_user_import_description:
    "Jede Demo ist ein eigenes Unternehmen und lässt sich so als Einheit filtern und löschen.",
  demo_user_credentials: "Zugangsdaten",
  demo_user_credentials_warning:
    "Diese Passwörter werden einmalig angezeigt und nirgends lesbar gespeichert. Lade sie jetzt herunter, wenn du sie brauchst.",
  download_csv: "CSV herunterladen",
  select_demo_company: "Unternehmen auswählen",
  demo_import: "Demo importieren",
  demo_import_description:
    "Lege einen Ordner mit einer manifest.json und je einer Analysedatei pro Sitzung ab. Erneutes Ablegen ist sicher: vorhandene Personen werden übersprungen, Sitzungen aktualisiert.",
  demo_drop_folder: "Demo-Ordner hier ablegen",
  demo_choose_folder: "oder Ordner auswählen",
  demo_import_action: "Demo importieren",
  demo_retry_failed: "Fehlgeschlagene wiederholen",
  demo_manifest_missing: "Der Ordner braucht eine {{name}}.",
  demo_manifest_unreadable: "Das Manifest konnte nicht gelesen werden.",
  demo_bundle_summary: "{{users}} Personen · {{sessions}} Sitzungen",
  demo_company_outside_band:
    "Unternehmens-id {{id}} liegt außerhalb des Demo-Bereichs {{min}}–{{max}}.",
  demo_owners_not_in_manifest:
    "Diese Eigentümer stehen nicht im Manifest und müssen bereits existieren: {{owners}}",
  demo_files_missing: "{{count}} im Manifest genannte Dateien fehlen im Ordner: {{files}}",
  demo_session_progress: "{{done}} von {{total}} erledigt",
  demo_failed_count: "{{count}} fehlgeschlagen",
  demo_owner_unresolved: 'Kein Benutzer mit dem Namen "{{owner}}"',
  demo_file_unreadable: "Die Analysedatei ist kein gültiges JSON",
  demo_no_owner: "kein Eigentümer",
  demo_usernames_taken:
    "Diese Benutzernamen gehören bereits zu Konten außerhalb dieser Demo, es wurde nichts angelegt: {{users}}",
  demo_users_skipped: "{{count}} Personen existierten bereits und blieben unverändert: {{users}}",
  demo_contents: "Inhalt der Demos",
  demo_contents_description:
    "Hier erscheinen nur angelegte Demo-Personen, und nur sie lassen sich löschen — ein echtes Konto ist von dieser Seite aus nie erreichbar.",
  delete_demo_user: "{{username}} löschen",
  delete_demo_session: "Sitzung löschen",
  delete_whole_demo: "Gesamte Demo {{name}} löschen",
  n_sessions: "{{count}} Sitzungen",
  n_sessions_one: "{{count}} Sitzung",
  no_demo_companies_to_delete:
    "Noch keine Demo zum Löschen. Unternehmen mit echten Benutzern erscheinen hier nie.",
} satisfies TourTranslation;
